import { createAction } from '@reduxjs/toolkit';
export const ADD_TEMPORARY_MESSAGE_SESSION = 'ADD_TEMPORARY_MESSAGE_SESSION';

export const addTemporaryMessageSessionAction = createAction(
  ADD_TEMPORARY_MESSAGE_SESSION,
  (temporaryMessageSession) => ({ payload: temporaryMessageSession })
);
